import SuggestedActionsDrawer from './SuggestedActionsDrawer.component';

export default SuggestedActionsDrawer;
